import { ref, watch, computed } from '@vue/composition-api'

import useJwt from "@/auth/jwt/useJwt";
import CISSettingService from '@/services/cis-setting.service'

import store from "@/store";

export default function cisSeedsList() {
  const refSeedsTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'subjectKor', label: 'subject', sortable: false },
    { key: 'topic1Kor', label: 'topic1', sortable: false },
    { key: 'topic2Kor', label: 'topic2', sortable: false },
    { key: 'categoryKor', label: 'category', sortable: false },
    { key: 'brandKor', label: 'brand', sortable: false },
    { key: 'lineKor', label: 'line', sortable: false },
    { key: 'productKor', label: 'product', sortable: false },
    { key: 'actions', sortable: false },
  ]
  const perPage = ref(10)
  const totalSeeds = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const listCtgSq = ref(1)

  const dataMeta = computed(() => {
    const localItemsCount = refSeedsTable.value ? refSeedsTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalSeeds.value,
    }
  })

  const reFetchData = () => {
    refSeedsTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    reFetchData()
  })

  const fetchSeeds = (ctx, callback) => {
    
    CISSettingService.seedList({
      search: searchQuery.value,
      pageNumber: currentPage.value - 1,
      pageSize: perPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      ctgSq: listCtgSq.value
    }).then(response => {
      if (response && response.data.success) {
        const { data, total } = response.data
        callback(data)
        totalSeeds.value = total
      }
    })
  }

  return {
    fetchSeeds,
    tableColumns,
    perPage,
    currentPage,
    totalSeeds,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refSeedsTable,

    statusFilter,

    reFetchData,
    listCtgSq
  }
}
